import * as React from "react";
import Svg, { Path } from "react-native-svg";
const SVGComponent = (props) => (
  <Svg
    width={props.width || 16}
    height={props.height || 16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M2 8H14"
      stroke={props.stroke || "white"}
      strokeWidth={2}
      strokeLinecap="round"
    />
    <Path
      d="M8 14L8 2"
      stroke={props.stroke || "white"}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </Svg>
);
export default SVGComponent;
